class MFRProductTopGallery {
  constructor(i, e) {
    this.$index = i
    this.$element = $(e)

    this.selectors = {
      carousel: ".product-top__images-carousel",
      thumbnailsWrapper: ".product-top__thumbs",
      thumbnail: ".product-top__thumb",
      productImage: ".product-top__images-inner",
      carouselImages: ".product-top__image"
    }

    this.init()
  }

  init() {
    this.$productImage = this.$element.find(this.selectors.productImage)
    this.$carousel = this.$element.find(this.selectors.carousel)

    this.initCarousel()
  }

  initCarousel() {
    this.$carousel.flickity({
      pageDots: false,
      prevNextButtons: false, 
      on: {
        ready: () => {
          this.changeImageOnSubscriptionSelect()
        }
      }
    })

    this.initThumbnails()
  }

  initThumbnails() {
    const wrapper = $(
      `<div class="${this.selectors.thumbnailsWrapper.replace(".", "")}-container">
        <div class="${this.selectors.thumbnailsWrapper.replace(".", "")}"></div>
      </div>`
    )

    this.$carousel.append(wrapper)
    this.$thumbnailsWrapper = this.$carousel.find(this.selectors.thumbnailsWrapper)
    this.generateThumbnails()

    $(this.selectors.thumbnailsWrapper).flickity({
      sync: this.selectors.carousel,
      contain: true,
      pageDots: false
    })
  }

  generateThumbnails() {
    const images = this.$carousel.find(this.selectors.carouselImages).each((i, e) => {
      const isActive = i == 0 ? "is-active" : ""
      const imageWrapperClass = this.selectors.thumbnail.replace(".", "")
      const isJpg = $(e).hasClass("is-jpg") ? "is-jpg" : "is-jpg"
      const imageWrapper = $(`<div class="${isActive} ${imageWrapperClass} ${isJpg}" data-index="${i}"></div>`)
      const imageClone = $(e).find("img").clone()

      imageWrapper.append(imageClone)
      lozad(imageClone.get(0)).observe()
      this.$thumbnailsWrapper.append(imageWrapper)
    })

    this.$image = this.$element.find(this.selectors.thumbnail)
    this.$image.on("click", this.handleThumbnailClick.bind(this))

    this.$carousel.on("select.flickity", (event, index) => {
      this.$image.removeClass("is-active")
      this.$thumbnailsWrapper.find(`${this.selectors.thumbnail}[data-index="${index}"]`).addClass("is-active")
    })
  }

  handleThumbnailClick(e) {
    this.$image.removeClass("is-active");
    this.$carousel.flickity("select", $(e.currentTarget).data("index"));
  }

  changeImageOnSubscriptionSelect() {
    if (!this.$carousel.data("flickity")) return
    const index = this.$element.find('[name="purchase_selector"]:checked').data("image-index")
    this.$carousel.flickity("selectCell", index)
  }
}